var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcOutlook(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "03-Appointment-expand",
    transform: "translate(-601.000000, -308.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-15",
    transform: "translate(225.000000, 147.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-24",
    transform: "translate(20.000000, 161.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-22",
    transform: "translate(356.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#1DB4CF",
    x: 0,
    y: 0,
    width: 40,
    height: 40,
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.51,11.0120922 C20.69,10.9745922 20.88125,11.0258422 21.02375,11.1445922 C21.1675,11.2633422 21.25,11.4395922 21.25,11.6258422 L21.25,11.6258422 L21.25,14.7508422 L29.375,14.7508422 C29.72,14.7508422 30,15.0308422 30,15.3758422 L30,15.3758422 L30,25.3758422 C30,25.7208422 29.72,26.0008422 29.375,26.0008422 L29.375,26.0008422 L21.25,26.0008422 L21.25,29.1258422 C21.25,29.3108422 21.1675,29.4883422 21.02375,29.6070922 C20.91125,29.7008422 20.77,29.7508422 20.625,29.7508422 C20.58625,29.7508422 20.5475,29.7470922 20.51,29.7395922 L20.51,29.7395922 L10.51,27.8645922 C10.21375,27.8095922 10,27.5508422 10,27.2508422 L10,27.2508422 L10,13.5008422 C10,13.1995922 10.21375,12.9420922 10.51,12.8870922 L10.51,12.8870922 Z M15.625,17.2508422 C13.9025,17.2508422 12.5,18.9333422 12.5,21.0008422 C12.5,23.0683422 13.9025,24.7508422 15.625,24.7508422 C17.3475,24.7508422 18.75,23.0683422 18.75,21.0008422 C18.75,18.9333422 17.3475,17.2508422 15.625,17.2508422 Z M28.75,16.6533422 L24.13375,20.2445922 C24.02125,20.3320922 23.885,20.3758422 23.75,20.3758422 C23.63375,20.3758422 23.51625,20.3433422 23.41375,20.2783422 L23.41375,20.2783422 L21.25,18.9020922 L21.25,24.7508422 L28.75,24.7508422 L28.75,16.6533422 Z M15.625,18.5008031 C16.6605339,18.5008031 17.5,19.6200913 17.5,21.0008031 C17.5,22.381515 16.6605339,23.5008031 15.625,23.5008031 C14.5894661,23.5008031 13.75,22.381515 13.75,21.0008031 C13.75,19.6200913 14.5894661,18.5008031 15.625,18.5008031 Z M27.55375,16.0008422 L21.25,16.0008422 L21.25,17.4208422 L23.71375,18.9870922 L27.55375,16.0008422 Z",
    id: "Combined-Shape",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcOutlook);
export default __webpack_public_path__ + "static/media/icOutlook.58325d3825b1926b6c34ff451ca50cbe.svg";
export { ForwardRef as ReactComponent };